/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProjectStageIdentifier } from '../../models/project-stage-identifier';
import { UpdateProjectStageCommandResult } from '../../models/update-project-stage-command-result';

export interface ApiProjectStagesUpdateProjectStagePatch$Params {
      body?: {
'StartDate'?: string;
'EndDate'?: string;
'Id': string;
'ContractNo'?: string;
'PrevId'?: string;
'IsActive'?: boolean;
'Identifier'?: ProjectStageIdentifier;
'Attachments'?: Array<Blob>;
}
}

export function apiProjectStagesUpdateProjectStagePatch(http: HttpClient, rootUrl: string, params?: ApiProjectStagesUpdateProjectStagePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectStageCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectStagesUpdateProjectStagePatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectStageCommandResult>;
    })
  );
}

apiProjectStagesUpdateProjectStagePatch.PATH = '/api/ProjectStages/UpdateProjectStage';
